import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import '@src/css/bootstrap.scss';

import './titles.scss';

const SectionTitleBlue = (props) => {
    const {
        as: As = 'h2',
        title,
    } = props;

    return (
        <Row className="section-title-blue">
            <Col>
                <As className="section-title-blue-title">{title}</As>
            </Col>
        </Row>
    );
};

SectionTitleBlue.propTypes = {
    as: PropTypes.string,
    title: PropTypes.string.isRequired,
};

export default SectionTitleBlue;
